/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from "components/MDBox";
import MDButton from "components/MDButton"; // Assuming you're using Material Design buttons
import { useAppServices } from "hook/services";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function DataTableData() {
  const AppService = useAppServices();
  const [List, setList] = useState([]);
  const [loader, setloader] = useState(true);
  const { id } = useParams();

  const getCategories = async () => {
    const { response } = await AppService.apikey_queries.getApikey({
       query: `query_id=${id}`,
    });
    if (response) {
      setList(response.data);
    } else {
      setList([]);
    }
    setloader(false);
  };

  const onLoad = () => {
    getCategories();
  };

  useEffect(onLoad, [id]);

  const downloadCSV = (record) => {
    const csvContent = [
      Object.keys(record).join(","), // headers
      Object.values(record).join(","), // values
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `${record.name || "record"}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return {
    loader: loader,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: "Api Key", accessor: "apiKey" },
        { Header: "Used", accessor: "used" },
        // { Header: "Action", accessor: "action" },
      ],

      rows: List.map((data) => ({
        apiKey: data.apiKey,
        used: data.used ? "Yes" : "No",
        // action: (
        //   <MDBox>
        //     <MDButton
        //       variant="outlined"
        //       color="primary"
        //       size="small"
        //       onClick={() => downloadCSV(data)}
        //     >
        //       Download CSV
        //     </MDButton>
        //   </MDBox>
        // ),
      })),
    },
  };
}

